import React, { useState, useEffect } from 'react';
import { Container, Row, Card, CardBody, Col } from 'reactstrap';
import { useParams, useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { partial } from '../../util/translation/translation';
import SubscriptionPrizeForm from './components/SubscriptionPrizeForm';
import Loading from '../../shared/components/custom/Loading';
import Api from '../../util/api';

const SubscriptionPrizeFormPage = () => {
  const { subscriptionPrizeID } = useParams();
  const history = useHistory();
  const [prize, setPrize] = useState(null);
  const [loading, setLoading] = useState(false);
  const s = partial('shared');
  const p = partial('goalSponsor');
  const getPrize = async () => {
    setLoading(true);
    try {
      const prizeData =
        await Api.goalSponsor.prizes.getPrizeById(subscriptionPrizeID);
      setPrize(prizeData);
      setLoading(false);
    } catch (err) {
      toast.error(JSON.stringify(err));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (subscriptionPrizeID) {
      getPrize();
    }
  }, [subscriptionPrizeID]);

  const onPrizeSubmit = async (values) => {
    const payload = {
      title: values.title,
      description: values.description,
      image: values.headingImage.croppedBase64 || values.headingImage.preview,
    };
    setLoading(true);
    try {
      if (subscriptionPrizeID) {
        await Api.goalSponsor.prizes.updatePrize(subscriptionPrizeID, payload);
      } else {
        await Api.goalSponsor.prizes.createPrize(payload);
      }
    } catch (err) {
      toast.error(err || s('somethingWentWrong'));
    } finally {
      setLoading(false);
      history.replace('/goal-sponsor?tab=2');
    }
  };

  return (
    <Container>
      <Loading loading={loading} />
      <Row>
        <Col>
          <h3 className="page-title">
            {subscriptionPrizeID ? `${s('edit')}` : `${s('create')}`}{' '}
            {p('subscriptionPrize')}
          </h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <SubscriptionPrizeForm
                onSubmit={onPrizeSubmit}
                prizeId={subscriptionPrizeID}
                subscriptionPrize={prize}
                type={subscriptionPrizeID ? 'edit' : 'create'}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SubscriptionPrizeFormPage;
